<template>
  <div class="form__field" style="width: 100%">
    <a
      class="mod mod--style--normal mod--theme--primary mod--size--14 mod--weight--400"
    >
      <span v-html="field.text"></span>
      <span
        v-html="field.buttonText"
        style="cursor: pointer"
        @click="changeProcessValue"
      ></span>
    </a>
  </div>
</template>

<script>
import * as Components from "@/components/checkout-fields/index";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-auth3-process-changer",
  methods: {
    changeProcessValue() {
      this.$store.dispatch("updateField", {
        field: this.processField,
        newProps: {
          value: this.value
        }
      });
    }
  }
};
</script>

<style scoped></style>
